import t from '@rcm/i18n-client';
import { geoCodesAreEqual } from 'cart-core';
import React, { ChangeEvent, useCallback, useMemo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import useGeoCodesByShippingQuery from '../../hooks/useGeoCodesByShippingQuery';
import { selectShippingGeoCode, setShippingGeoCode } from '../../slices/shipping';

const ShippingCityByGeoCodeField = () => {
    const dispatch = useDispatch();
    const geoCode = useSelector(selectShippingGeoCode);
    const geoCodesQuery = useGeoCodesByShippingQuery();

    const geoCodeIndex = useMemo(() => (
        geoCodesQuery.data?.findIndex((gc) => geoCodesAreEqual(gc, geoCode)) ?? -1
    ), [geoCodesQuery.data, geoCode]);

    const handleChange = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
        dispatch(setShippingGeoCode(geoCodesQuery?.data[e.target.value]));
    }, [dispatch, geoCodesQuery.data]);

    return (
        (geoCodesQuery.isFetching || geoCodesQuery.isSuccess) && <Row className="mb-3">
            <Form.Group as={Col}>
                <Form.Label>{t('City')}</Form.Label>
                <Form.Select
                    disabled={geoCodesQuery.isFetching}
                    onChange={handleChange}
                    value={geoCodeIndex}
                >
                    {geoCodesQuery.isFetching && <option value={-1} disabled>
                        {t('Loading...')}
                    </option>}
                    {geoCodesQuery.isSuccess && <>
                        <option value={-1} disabled>
                            - {t('Select an Option')} -
                        </option>
                        {(geoCodesQuery.data ?? []).map((geoCode, i) => (
                            <option value={i} key={i}>{geoCode.label}</option>
                        ))}
                    </>}
                </Form.Select>
            </Form.Group>
        </Row>
    );
}

export default ShippingCityByGeoCodeField;
